import Locations from '@/common/models/geo/Location';
import MarketModel from '@/common/models/geo/Market';
import MediaType from '@/common/models/misc-api-models/MediaType';
import NetworkModel from '@/common/models/misc-api-models/Network';

export enum BreakdownParameterEnum {
  City = 'city',
  Market = 'market',
  VenueType = 'venue_type',
  Network = 'network',
  MediaOwner = 'media_owner',
}

export type TTypeOfData = 'data-budget-breakdown' | 'data-totals';

export type TargetingItem = Locations | MarketModel | MediaType | NetworkModel;

export type TInventoryTargeting = Record<BreakdownParameterEnum, TargetingItem[]>;

export type TBreakdownTypeAPI = `${BreakdownParameterEnum}`;

export enum AudienceConcentrationTypeMapping {
  network = 'networks',
  city = 'cities',
  market = 'markets',
  venue_type = 'mediatypes',
}

// Type guards
export const isLocation = (props: TargetingItem): props is Locations =>
  Object.prototype.hasOwnProperty.call(props, 'locations');
export const isMediaType = (props: TargetingItem): props is MediaType =>
  Object.prototype.hasOwnProperty.call(props, 'enumerationId');
